<template>
  <div class="cloudShop" v-show="shopType===1">
    <div class="shopHeader">
      <div>
        <div>
          <a :href="homeURL"><img src="@/assets/logo.png"></a>
          <div class="mobileLogo">
            <img :src="detail.logo?(detail.logo):require('@/assets/cloud_shop.png')">
          </div>
          <div class="shopInfo">
            <div>
              <div>{{ detail.title }}</div>
              <div>
                <div class="infoYears">{{ detail.ying }}年</div>
                <img v-for="(item,i) in detail.brand" :key="i" :src="item.url">
                <img :src="detail.shop_level_url">
              </div>
            </div>
            <div>
              <!-- <div>
            <div>10.00</div>
            <div>商品<br>丰富</div>
          </div>
          <div>
            <div>10.00</div>
            <div>快速<br>响应</div>
          </div>
          <div>
            <div>10.00</div>
            <div>供应链<br>支持</div>
          </div>
          <div>
            <div>10.00</div>
            <div>供货<br>稳定</div>
          </div> -->
            </div>
          </div>
        </div>
        <a-input-search class="searchInput" v-model="searchTitle" allowClear placeholder="请输入产品名称" enter-button="搜索" size="large" @search="onSearch">
          <div slot="prefix" class="searchSelector">
            <span class="iconfont icon-search" style="font-size:20px"></span>
          </div>
        </a-input-search>
      </div>
    </div>
    <div class="shopLogo" v-for="(item,i) in topImg" :key="i">
      <img :src="item.img_url">
    </div>
    <div class="shopNav">
      <div :class="navIndex==='0'?'active':''" @click="navChange('0')">首页</div>
      <div :class="navIndex==='1'?'active':''" @click="navChange('1')">供应产品</div>
      <div :class="navIndex==='2'?'active':''" @click="navChange('2')">公司介绍</div>
      <div :class="navIndex==='3'?'active':''" @click="navChange('3')">公司动态</div>
      <!-- <div :class="navIndex==='4'?'active':''" @click="navChange('4')">公司案例</div> -->
    </div>
    <ShopIndex @toShop="navChange('0')" @allGoods="navChange('1')" :activeIndex="activeIndex" v-if="navIndex==='0'" :teban="teban" :detail="detail" :supplyGoods="supplyGoods" :list="list" :banner="banner" :types="types" :goodsLoading="goodsLoading" @collapseChange="collapseChange"></ShopIndex>
    <GoodsList @toShop="navChange('0')" @allGoods="navChange('1')" :activeIndex="activeIndex" v-if="navIndex==='1'" :detail="detail" :supplyGoods="supplyGoods" :list="list" :types="types" :total="total" :goodsLoading="goodsLoading" @collapseChange="collapseChange" @pageChange="pageChange"></GoodsList>
    <CompanyIntro @toShop="navChange('0')" @allGoods="navChange('1')" v-if="navIndex==='2'" :detail="detail"></CompanyIntro>
    <CompanyDynamic @toShop="navChange('0')" @allGoods="navChange('1')" v-if="navIndex==='3'" :loading="dynastisLoading" :dynastisCount="dynastisCount" :dynamicsSize="dynamicsSize" :dynamicsNum="dynamicsNum" :detail="detail" :list="dynamicsList" :shopId="detail.id" :link="detail.link" @sizeChange="dynamicsSizeChange" @pageChange="dynamicsPageChange"></CompanyDynamic>
  </div>
</template>
<script>
import {
  shopInfo,
  shopGoods,
  shopBanner,
  productClass,
  companyDynamics,
  addHit
} from "@/api/shop";
import { dailyViews,shopVisit } from "@/api/home";
import ShopIndex from "@/components/shopIndex.vue";
import GoodsList from "@/components/goodsList.vue";
import CompanyIntro from "@/components/companyIntro.vue";
import CompanyDynamic from "@/components/companyDynamic.vue";
export default {
  components: { ShopIndex, GoodsList, CompanyIntro, CompanyDynamic },
  data() {
    return {
      homeURL: process.env.VUE_APP_HOME,
      shopType:null,
      activeIndex:null,
      dynamicsSize:10,
      dynamicsNum:1,
      dynastisCount:0,
      dynastisLoading:false,
      detail: {
        enterprise: {
          business_license: null,
          authorize_letter: null,
        },
      },
      icons: [
        require("@/assets/cloudshop_icon1.png"),
        require("@/assets/cloudshop_icon2.png"),
        require("@/assets/cloudshop_icon3.png"),
        require("@/assets/cloudshop_icon4.png"),
      ],
      navIndex: "0",
      list: [],
      supplyGoods: [],
      topImg: [],
      banner: [],
      teban: [],
      types: [],
      collapseId: "",
      goodsLoading: false,
      total: 0,
      pageNumber: 1,
      pageSize: 20,
      searchTitle: "",
      dynamicsList: [],
    };
  },
  computed: {
    baseUrl() {
      return this.$store.state.baseUrl;
    },
  },
  methods: {
    addShopVisit(id){
      const data={
        shop_id:id,
        link:''
      }
      shopVisit(data).then(res=>{
        if(!res.data){
          console.log(res.message)
        }
      })
    },
    addDailyViews(id){
      const data={
        type:'店铺',
        shop_id:id,
        link:''
      }
      dailyViews(data).then(res=>{
        if(!res.data){
          console.log(res.message)
        }
      })
    },
    dynamicsSizeChange(e){
      this.dynamicsSize=e
      this.dynamicsNum=1
      this.getDynamics()
    },
    dynamicsPageChange(e){
      this.dynamicsNum=e
      this.getDynamics()
    },
    addHits(){
      let link=this.$route.params.link;
      let data={};
      if(link){
        data.link=link
      }else{
        data.id=this.$route.query.id
      }
      addHit(data).then(()=>{
        // console.log(res);
      })
    },
    getDynamics() {
      this.dynastisLoading=true
      let link=this.$route.params.link;
      let data = {
        pageSize: this.dynamicsSize,
        pageNumber: this.dynamicsNum,
      };
      if(link){
        data.link=link
      }else{
        data.id=this.$route.query.id
      }
      companyDynamics(data).then((res) => {
        this.dynamicsList = res.data.data;
        this.dynastisCount=res.data.count;
        this.dynastisLoading=false;
      });
    },
    pageChange(e) {
      this.pageSize = e[1];
      this.pageNumber = e[0];
      this.getGoods();
    },
    collapseChange(id) {
      this.collapseId = id;
      this.getGoods();
    },
    getTypes() {
      let link=this.$route.params.link;
      let data={};
      if(link){
        data.link=link
      }else{
        data.id=this.$route.query.id
      }
      productClass(data).then((res) => {
        this.types = res.data.data;
      });
    },
    getInfo() {
      let link=this.$route.params.link;
      let data={};
      if(link){
        data.link=link
      }else{
        data.id=this.$route.query.id
      }
      shopInfo(data).then((res) => {
        if (res.code == 200) {
          if(res.data.type===0){
            this.$router.push('/removedShop')
            return
          }else{
            this.shopType=res.data.type;
            this.detail = res.data.data;
            this.supplyGoods = res.data.retui;
            document.title = this.detail.title;
            this.addDailyViews(res.data.data.id);
            this.addShopVisit(res.data.data.id);
          }
        }
      });
    },
    getBanner() {
      let link=this.$route.params.link;
      let data={};
      if(link){
        data.link=link
      }else{
        data.id=this.$route.query.id
      }
      shopBanner(data).then((res) => {
        if (res.code == 200) {
          this.banner = res.data.data.banner;
          this.topImg = res.data.data.guangGao;
          this.teban = res.data.data.teban;
        }
      });
    },
    getGoods() {
      this.goodsLoading = true;
      let link=this.$route.params.link;
      let data = {
        title: this.searchTitle,
        type: this.collapseId,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      };
      if(link){
        data.link=link
      }else{
        data.shop_id=this.$route.query.id
      }
      shopGoods(data).then((res) => {
        if (res.data.result) {
          this.list = res.data.data;
          this.total = res.data.total;
          this.initService();
          this.$forceUpdate();
        } else {
          this.$message.error(res.message);
        }
        this.goodsLoading = false;
      });
    },
    onSearch(e) {
      this.searchTitle = e;
      this.activeIndex=null;
      this.navIndex = '1';
      this.collapseId = "";
      this.pageNumber = 1;
      this.pageSize = 20;
      this.getGoods();
    },
    navChange(i) {
      this.navIndex = i;
      this.collapseId = "";
      this.searchTitle = "";
      this.pageNumber = 1;
      this.pageSize = 20;
      this.addHits();
      this.getGoods();
      this.addDailyViews(this.detail.id);
      this.addShopVisit(this.detail.id);
    },
    initService(){
      const obj=document.getElementsByClassName("zhiCustomBtn");
      for(let i=0;i<obj.length;i++){
        obj[i].onclick=function(){
          // eslint-disable-next-line no-undef
          zc("dynamic_ready")
        }
      }
    },
  },
  mounted() {
    window.scrollTo({
      top: 0,
    });
    if (this.$route.query.index) {
      this.navIndex = this.$route.query.index;
      this.searchTitle=this.$route.query.keyword?this.$route.query.keyword:'';
    } else {
      this.navIndex = "0";
    }
    this.getInfo();
    this.getGoods();
    this.getBanner();
    this.getTypes();
    this.getDynamics();
  },
};
</script>
<style lang="less">
@media screen and (min-width: 1025px) {
  .cloudShop {
    width: 100%;
    min-width: 1200px;
    padding:0 !important;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f1f1f1;
    .shopHeader {
      background-color: #fff;
      width: 100%;
      > div {
        width: 1200px;
        padding: 20px 0;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        > div:first-child {
          display: flex;
          align-items: center;
          width:calc(100% - 450px);
          > a {
            height: 40px;
            img {
              width: 200px;
              height: 40px;
            }
          }
        }
        .mobileLogo{
          display:none;
        }
        .shopInfo {
          width:calc(100% - 200px);
          justify-content: center;
          display: flex;
          align-items: end;
          > div:first-child {
            font-size: 16px;
            text-align: left;
            margin-right: 20px;
            > div {
              display: flex;
              align-items: center;
              // width: 192px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom:10px;
            }
          }
          > div:last-child {
            display: flex;
            align-items: center;
            > div {
              text-align: center;
              margin-right: 16px;
              > div:first-child {
                font-size: 18px;
                color: var(--default);
              }
              > div:last-child {
                height: 30px;
                font-size: 12px;
                color: #999999;
              }
            }
          }
          img {
            height: 20px;
            width: auto;
            margin-right: 16px;
          }
          .infoYears{
            width: 50px;
            height: 20px;
            line-height: 20px;
            background-image: url('@/assets/years.png');
            background-size: 100% 100%;
            border-radius: 2px;
            font-size: 12px;
            color: #C81528;
            text-align: right;
            padding-right:4px;
            margin-right:14px;
          }
        }
        .searchInput {
          width: 450px;
          height: 40px;
        }
        .searchInput .ant-input {
          padding-left: 40px;
          border: 2px solid var(--default) !important;
        }
      }
    }
    .shopLogo {
      width: 100%;
      min-width: 1200px;
      height: auto;
      > img {
        max-width: 100%;
        height: 100%;
      }
    }
    .shopNav {
      width: 100%;
      background-color: #fff;
      display: inline-flex;
      justify-content: center;
      > div {
        height: 60px;
        font-size: 18px;
        line-height: 60px;
        margin: 0 32px;
        box-sizing: border-box;
        cursor: pointer;
      }
      > div:hover {
        color: var(--default);
      }
      .active {
        color: var(--default);
        border-bottom: 2px solid var(--default);
        font-size:18px;
        font-weight:600;
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .cloudShop {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f1f1f1;
    .shopHeader {
      background-color: #fff;
      width: 100%;
      > div {
        width: 100%;
        padding: 12px;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        > div:first-child {
          display: flex;
          > a{
            display:none;
          }
        }
        .mobileLogo{
          margin-right:12px;
          background-image: linear-gradient(
            18deg,
            #d03d3c 11%,
            #f3c2c2 87%
          );
          padding: 2px;
          width:50px;
          height:50px;
          border-radius: 50%;
          display:inline-block;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          } 
        }
        .shopInfo {
          width:calc(100% - 62px);
          display: flex;
          align-items: center;
          > div:first-child {
            text-align: left;
            font-weight: 600;
            margin-right: 20px;
            > div {
              // width: 192px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              display:flex;
              align-items: center;
              flex-wrap: wrap;
            }
          }
          > div:last-child {
            display: flex;
            align-items: center;
            > div {
              text-align: center;
              margin-right: 16px;
              > div:first-child {
                font-size: 18px;
                color: var(--default);
              }
              > div:last-child {
                height: 30px;
                font-size: 12px;
                color: #999999;
              }
            }
          }
          img {
            height: 20px;
            width: auto;
            margin-right: 16px;
            margin-top: 5px;
          }
          .infoYears{
            width: 45px;
            height: 20px;
            line-height: 20px;
            background-image: url('@/assets/years.png');
            background-size: 100% 100%;
            border-radius: 2px;
            font-size: 12px;
            color: #C81528;
            text-align: right;
            padding-right:4px;
            margin-right:16px;
            margin-top:5px;
          }
        }
        .searchInput {
          display:none;
        }
        .searchInput .ant-input {
          padding-left: 40px;
          border: 2px solid var(--default) !important;
        }
      }
    }
    .shopLogo {
      display:none;
      // width: 100%;
      // height: auto;
      // > img {
      //   width: 100%;
      //   height: 100%;
      // }
    }
    .shopNav {
      width: 100%;
      background-color: #fff;
      display: inline-flex;
      justify-content: center;
      > div {
        height: 44px;
        line-height: 44px;
        margin: 0 12px;
        box-sizing: border-box;
        cursor: pointer;
        font-size:16px;
      }
      > div:hover {
        color: var(--default);
      }
      .active {
        color: var(--default);
        border-bottom: 2px solid var(--default);
        font-weight: 600;
      }
    }
  }
}
</style>